import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchCarrierResdit7421PerformanceOperator = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarrierResdit7421PerformanceOperator',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarrierResdit7421PerformanceOperator;
